/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/hab_dome': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16.4 21.406c1.051-.262 1.6-1 1.6-2s-1-2-2-2-2 1-2 2 .582 1.738 1.6 2c-.6 0-1.6 1-1.6 3V28h4v-3.594c0-2-1-3-1.6-3zM25.293 16.061L16 6.768l-9.293 9.293-1.414-1.415L16 3.939l10.707 10.707zM8.5 32H0v-8.5h1V31h7.5zM14.27 31h3.462v1H14.27zM32 32h-8.5v-1H31v-7.5h1zM31 14.27h1v3.461h-1zM32 8.5h-1V1h-7.5V0H32zM14.269 0h3.462v1h-3.462zM1 8.5H0V0h8.5v1H1zM0 14.269h1v3.461H0z"/>'
  }
})
